<mat-card>
  <mat-card-content>
    <mat-card-title>{{ title }}</mat-card-title>

    <mat-accordion>
      @for (env of environments; track env) {
        <mat-expansion-panel>
          <mat-expansion-panel-header [ngClass]="getEnvironmentStatusClass(env)">
            <mat-panel-title [ngClass]="getPanelTitleClass(getEnvironmentStatusClass(env))">
              {{ env.name }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          @for (phase of env.deployPhases; track phase) {
            <mat-expansion-panel>
              <mat-expansion-panel-header [ngClass]="getDeployPhaseStatusClass(phase)">
                <mat-panel-title [ngClass]="getPanelTitleClass(getDeployPhaseStatusClass(phase))">
                  {{ phase.name }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              @for (task of phase.workflowTasks; track task) {
                <mat-expansion-panel>
                  <mat-expansion-panel-header [ngClass]="getWorkflowTaskStatusClass(task)">
                    <mat-panel-title [ngClass]="getPanelTitleClass(getWorkflowTaskStatusClass(task), task)">
                      {{ task.name }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <app-workflow-task [wfTask]="task" [serviceConnections]="serviceConnections"></app-workflow-task>
                </mat-expansion-panel>
              }
            </mat-expansion-panel>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </mat-card-content>
</mat-card>